// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public/images/exchange_herobg.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Copy Trading — premium static look on Vorienx theme
   Colors: #0a0a0a, #2563eb, #5EC732, #F6CF25, #F52534
   No animations / transitions / motion */

.ct-page {
  min-height: 100vh;
}

section.earning_outer_s.ct-page {
  position: relative;
  background-color: #0a0a0a;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center top;
  background-size: cover;
  background-repeat: no-repeat;
  padding: 110px 0 80px;
  overflow: hidden;
}

section.earning_outer_s.ct-page::after {
  content: "";
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.38);
  pointer-events: none;
}

.ct-page > .container {
  position: relative;
  z-index: 1;
}

.ct-hero {
  margin: 0 0 32px;
  max-width: 680px;
}

.ct-hero .ct-kicker {
  color: #fff;
  margin-bottom: 12px;
}

.ct-hero h1 {
  margin: 0 0 12px;
  font-size: 46px;
  font-weight: 800;
  line-height: 1.12;
  letter-spacing: -0.8px;
  color: #fff;
}

.ct-hero p {
  margin: 0;
  font-size: 17px;
  line-height: 1.55;
  color: #d4d4d4;
  max-width: 560px;
}

.ct-page .earning_section_cate {
  margin-bottom: 8px;
  overflow: visible;
  background: rgba(10, 10, 10, 0.82);
  border: 1px solid rgba(120, 120, 120, 0.45);
}

.ct-page .earning_right_tab {
  width: 100%;
}

.ct-page .earning_right_tab .nav-tabs {
  flex-wrap: wrap;
  justify-content: flex-start;
}

.ct-page-head {
  position: relative;
  z-index: 1;
  margin-bottom: 8px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(120, 120, 120, 0.35);
}

.ct-page .earning_tp_heading {
  align-items: flex-start;
}

.ct-page .earning_tp_heading h4 {
  letter-spacing: -0.3px;
}

.ct-page-sub {
  margin: 4px 0 0;
  font-size: 12px;
  color: #9b9999;
  font-weight: 400;
  line-height: 1.45;
}

.ct-kicker {
  display: inline-block;
  margin-bottom: 8px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  color: #9b9999;
}

.ct-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  margin: 8px 0 26px;
}

.ct-search {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 0 0 280px;
  max-width: 100%;
  background: #222222;
  border: 1px solid #7878789c;
  border-radius: 50px;
  padding: 8px 16px;
}

.ct-search i {
  color: #9b9999;
  font-size: 16px;
  line-height: 1;
  flex-shrink: 0;
}

.ct-search input {
  flex: 1 1;
  min-width: 0;
  width: 100%;
  border: none;
  outline: none;
  background: transparent;
  color: #fff;
  font-size: 14px;
  font-weight: 400;
}

.ct-search input::placeholder {
  color: #9b9999;
}

.ct-search input:focus {
  border: none;
  outline: none;
  box-shadow: none;
}

.ct-notice {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  max-width: 560px;
  padding: 10px 14px;
  border-radius: 12px;
  background: transparent;
  border: 1px solid #7878789c;
}

.ct-notice p {
  margin: 0;
  font-size: 12px;
  line-height: 1.5;
  color: #9b9999;
}

.ct-notice-dot {
  width: 6px;
  height: 6px;
  margin-top: 6px;
  border-radius: 50%;
  background: #787878;
  box-shadow: none;
  flex-shrink: 0;
}

.ct-master-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 22px;
}

.ct-master-card,
.ct-follow-card,
.ct-detail-stat,
.ct-pnl-hero {
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.04) 0%, rgba(255, 255, 255, 0.015) 100%);
  border: 1px solid rgba(120, 120, 120, 0.42);
  position: relative;
}

.ct-master-card {
  background: #0a0a0a;
  border: 1px solid #7878789c;
  border-radius: 16px;
  padding: 20px 18px 16px;
  display: flex;
  flex-direction: column;
  min-height: 100%;
  overflow: hidden;
  box-shadow: none;
}

.ct-master-card::before {
  display: none;
}

.ct-master-card.is-following {
  border-color: #7878789c;
}

.ct-master-card .ct-avatar-wrap {
  padding: 0;
  background: #1a1a1a;
  border: 1px solid #7878789c;
}

.ct-master-card .ct-avatar {
  border-color: #0a0a0a;
}

.ct-master-card .ct-chip.pair,
.ct-master-card .ct-chip.following {
  color: #cfcfcf;
  background: transparent;
  border-color: #7878789c;
  font-weight: 600;
}

.ct-master-card .ct-win-badge {
  background: transparent;
  color: #cfcfcf;
  border-color: #7878789c;
  font-weight: 600;
}

.ct-master-card .ct-rating-stars i {
  color: #F6CF25;
}

.ct-master-card .ct-rating-stars i.empty {
  color: rgba(246, 207, 37, 0.28);
}

.ct-master-card .ct-rating-value {
  color: #fff;
}

.ct-master-card .ct-stat,
.ct-master-card .ct-stat.profit,
.ct-master-card .ct-stat.loss {
  background: transparent;
  border: 1px solid #7878789c;
  border-radius: 10px;
}

.ct-master-card .ct-alloc-item,
.ct-master-card .ct-alloc-item.gold {
  background: transparent;
  border: 1px solid #7878789c;
  border-radius: 10px;
}

.ct-master-card .ct-alloc-item.gold strong {
  color: #fff;
}

.ct-master-card .ct-btn.primary {
  box-shadow: none;
}

.ct-master-card-head {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  margin-bottom: 16px;
}

.ct-master-card-head .ct-master-copy {
  flex: 1 1;
  min-width: 0;
}

.ct-avatar-wrap {
  width: 62px;
  height: 62px;
  border-radius: 50%;
  padding: 0;
  background: #1a1a1a;
  border: 1px solid #7878789c;
  flex-shrink: 0;
}

.ct-avatar-wrap.lg {
  width: 96px;
  height: 96px;
  padding: 0;
}

.ct-avatar-wrap.is-following {
  background: #1a1a1a;
  border-color: #7878789c;
}

.ct-avatar {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
  background: #111;
  display: block;
  border: 2px solid #0a0a0a;
}

.ct-name-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.ct-master-name {
  margin: 0;
  font-size: 19px;
  font-weight: 700;
  color: #fff;
  letter-spacing: -0.2px;
}

.ct-master-bio {
  margin: 7px 0 0;
  font-size: 13px;
  color: #9b9999;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.ct-rating {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
}

.ct-rating-stars {
  display: inline-flex;
  align-items: center;
  gap: 2px;
}

.ct-rating-stars i {
  font-size: 14px;
  line-height: 1;
  color: #F6CF25;
}

.ct-rating-stars i.empty {
  color: rgba(246, 207, 37, 0.28);
}

.ct-rating-value {
  font-size: 13px;
  font-weight: 700;
  color: #fff;
  letter-spacing: -0.2px;
}

.ct-rating.none .ct-rating-value {
  color: #9b9999;
  font-weight: 600;
}

.ct-rating.lg {
  margin: 10px 0 2px;
}

.ct-rating.lg .ct-rating-stars i {
  font-size: 20px;
}

.ct-rating.lg .ct-rating-value {
  font-size: 20px;
}

.ct-win-badge {
  display: inline-flex;
  align-items: center;
  background: transparent;
  color: #cfcfcf;
  border: 1px solid #7878789c;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.3px;
  padding: 5px 11px;
  border-radius: 50px;
  white-space: nowrap;
  margin-left: auto;
}

.ct-chip-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 0 0 16px;
}

.ct-chip {
  display: inline-flex;
  align-items: center;
  font-size: 11px;
  font-weight: 700;
  color: #cfcfcf;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.09);
  border-radius: 50px;
  padding: 4px 10px;
}

.ct-chip.pair,
.ct-chip.following {
  color: #cfcfcf;
  background: transparent;
  border-color: #7878789c;
  font-weight: 600;
}

.ct-stats {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin: 0 0 14px;
}

.ct-stat {
  background: rgba(0, 0, 0, 0.32);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 14px;
  padding: 12px 13px;
  border-left: 2px solid rgba(37, 99, 235, 0.55);
}

.ct-stat.profit {
  border-left-color: #5EC732;
}

.ct-stat.loss {
  border-left-color: #F52534;
}

.ct-stat label,
.ct-alloc-item label,
.ct-follow-pnl label {
  display: block;
  font-size: 10px;
  color: #9b9999;
  text-transform: uppercase;
  letter-spacing: 0.7px;
  margin-bottom: 5px;
}

.ct-stat span {
  font-size: 15px;
  font-weight: 700;
  color: #fff;
  letter-spacing: -0.2px;
}

.ct-alloc {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin: 0 0 16px;
}

.ct-alloc-item,
.ct-alloc-item.gold {
  background: transparent;
  border: 1px solid #7878789c;
  border-radius: 10px;
  padding: 11px 13px;
}

.ct-alloc-item strong,
.ct-alloc-item.gold strong {
  display: block;
  font-size: 18px;
  font-weight: 700;
  color: #fff;
  letter-spacing: -0.3px;
}

.ct-note {
  font-size: 12px;
  color: #9b9999;
  margin: 0 0 16px;
  line-height: 1.5;
}

.ct-note strong {
  color: #fff;
  font-weight: 600;
}

.ct-card-actions {
  display: flex;
  gap: 10px;
  margin-top: auto;
}

.ct-btn {
  flex: 1 1;
  border: none;
  padding: 11px 16px;
  font-size: 13px;
  font-weight: 700;
  border-radius: 50px;
  cursor: pointer;
  text-align: center;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
}

.ct-btn.primary {
  background-color: #2563eb;
  color: #fff;
  box-shadow: none;
}

.ct-btn.primary:hover {
  background-color: #1d4ed8;
  color: #fff;
}

.ct-btn.light {
  background-color: #fff;
  color: #000;
}

.ct-btn.light:hover {
  background-color: #e8e8e8;
  color: #000;
}

.ct-btn.outline {
  background: transparent;
  border: 1px solid #7878789c;
  color: #fff;
}

.ct-btn.outline:hover {
  border-color: #fff;
  color: #fff;
}

.ct-btn.danger {
  background: transparent;
  border: 1px solid rgba(245, 37, 52, 0.7);
  color: #F52534;
}

.ct-btn.danger:hover {
  background: rgba(245, 37, 52, 0.12);
}

.ct-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
  box-shadow: none;
}

.ct-pnl-positive {
  color: #5EC732 !important;
}

.ct-pnl-negative {
  color: #F52534 !important;
}

.ct-status {
  display: inline-block;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.4px;
  padding: 4px 10px;
  border-radius: 50px;
}

.ct-status.open {
  background: rgba(246, 207, 37, 0.15);
  color: #F6CF25;
}

.ct-status.executed {
  background: rgba(94, 199, 50, 0.15);
  color: #5EC732;
}

.ct-status.cancelled {
  background: rgba(155, 153, 153, 0.18);
  color: #9b9999;
}

.ct-side.buy {
  color: #5EC732;
  font-weight: 700;
}

.ct-side.sell {
  color: #F52534;
  font-weight: 700;
}

.ct-login-prompt {
  text-align: center;
  padding: 40px 16px;
}

.ct-login-prompt a {
  color: #2563eb;
  font-weight: 700;
}

.ct-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
  margin: 18px 0 20px;
}

.ct-filters select {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid #7878789c;
  color: #fff;
  border-radius: 50px;
  padding: 9px 16px;
  font-size: 14px;
  outline: none;
  min-width: 160px;
}

.ct-filters select option {
  background: #111;
  color: #fff;
}

.ct-filters .ct-notice {
  flex: 1 1 280px;
  max-width: none;
}

.ct-pnl-hero {
  border-radius: 20px;
  padding: 36px 24px 32px;
  margin: 18px 0 24px;
  text-align: center;
  overflow: hidden;
  background:
    radial-gradient(700px 180px at 50% 0%, rgba(37, 99, 235, 0.2), transparent 70%),
    linear-gradient(180deg, rgba(255, 255, 255, 0.04) 0%, rgba(255, 255, 255, 0.015) 100%);
}

.ct-pnl-hero label {
  display: block;
  color: #9b9999;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 1.2px;
  margin-bottom: 10px;
}

.ct-pnl-hero h2 {
  margin: 0 auto;
  font-size: 44px;
  font-weight: 700;
  letter-spacing: -0.8px;
  display: inline-block;
  padding-bottom: 10px;
  border-bottom: 2px solid rgba(246, 207, 37, 0.45);
}

.ct-pnl-hero .ct-page-sub {
  margin-top: 12px;
}

.ct-follow-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px;
  margin-top: 8px;
}

.ct-follow-card {
  border-radius: 20px;
  padding: 18px 20px;
  display: flex;
  align-items: center;
  gap: 16px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.05);
}

.ct-follow-card .ct-follow-meta {
  flex: 1 1;
  min-width: 0;
}

.ct-follow-card h5 {
  margin: 0;
  font-size: 16px;
  color: #fff;
  font-weight: 700;
}

.ct-follow-card p {
  margin: 6px 0 0;
  font-size: 13px;
  color: #9b9999;
}

.ct-follow-pnl {
  min-width: 128px;
  text-align: right;
}

.ct-follow-pnl strong {
  display: block;
  font-size: 16px;
  font-weight: 700;
  color: #fff;
}

.ct-follow-actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 118px;
  flex-shrink: 0;
}

.ct-detail-head {
  display: flex;
  align-items: flex-start;
  gap: 24px;
  flex-wrap: wrap;
  margin-bottom: 26px;
  position: relative;
  z-index: 1;
}

.ct-detail-info {
  flex: 1 1;
  min-width: 240px;
}

.ct-detail-info h2 {
  margin: 0;
  font-size: 32px;
  font-weight: 700;
  color: #fff;
  letter-spacing: -0.5px;
}

.ct-detail-info > p {
  margin: 10px 0 16px;
  color: #9b9999;
  line-height: 1.6;
  max-width: 640px;
}

.ct-detail-info .ct-win-badge {
  margin-left: 0;
}

.ct-detail-info .ct-alloc {
  max-width: 420px;
  margin-bottom: 14px;
}

.ct-detail-info .ct-notice {
  margin-bottom: 16px;
}

.ct-detail-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.ct-detail-actions .ct-btn {
  flex: 0 0 auto;
  min-width: 168px;
}

.ct-back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #cfcfcf;
  font-size: 14px;
  text-decoration: none;
  margin-bottom: 18px;
  position: relative;
  z-index: 1;
}

.ct-back:hover {
  color: #fff;
}

.ct-detail-stats {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
  margin-bottom: 4px;
}

.ct-detail-stat {
  background: #0a0a0a;
  border: 1px solid #7878789c;
  border-radius: 12px;
  padding: 16px;
  overflow: hidden;
  box-shadow: none;
}

.ct-detail-stat.profit,
.ct-detail-stat.loss,
.ct-detail-stat.win {
  border-color: #7878789c;
}

.ct-detail-stat label {
  display: block;
  font-size: 11px;
  color: #9b9999;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  margin-bottom: 8px;
}

.ct-detail-stat span {
  font-size: 20px;
  font-weight: 700;
  color: #fff;
  letter-spacing: -0.3px;
}

.ct-section-title {
  margin: 0 0 16px;
  font-size: 20px;
  font-weight: 700;
  color: #fff;
  letter-spacing: -0.2px;
}

.ct-table-card {
  margin-top: 24px;
}

.ct-pagination {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  margin-top: 16px;
  color: #9b9999;
  font-size: 13px;
}

.ct-pagination button {
  background: transparent;
  border: 1px solid #7878789c;
  color: #fff;
  border-radius: 50px;
  padding: 6px 14px;
  cursor: pointer;
}

.ct-pagination button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.ct-page .recenttable_s table {
  width: 100%;
}

.ct-page .recenttable_s table thead tr th {
  background-color: transparent;
  color: #ffffff99;
  font-weight: 600;
  white-space: nowrap;
  font-size: 12px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  border-bottom: 1px solid #7878789c;
  padding: 12px 12px;
}

.ct-page .recenttable_s table tbody tr td {
  padding: 15px 12px;
  font-size: 14px;
  color: #fff;
  border-bottom: 1px solid rgba(120, 120, 120, 0.24);
  white-space: nowrap;
}

.ct-clickable {
  cursor: pointer;
}

.ct-clickable:hover {
  background: rgba(37, 99, 235, 0.08);
}

@media (max-width: 1199.98px) {
  .ct-master-grid,
  .ct-follow-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .ct-detail-stats {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 767.98px) {
  .ct-hero {
    margin-bottom: 22px;
  }

  .ct-hero h1 {
    font-size: 32px;
  }

  .ct-master-grid,
  .ct-follow-grid,
  .ct-detail-stats,
  .ct-alloc {
    grid-template-columns: 1fr;
  }

  .ct-toolbar {
    flex-direction: column;
    align-items: stretch;
  }

  .ct-toolbar .ct-search {
    flex: 1 1 auto;
    width: 100%;
  }

  .ct-detail-head {
    flex-direction: column;
  }

  .ct-card-actions,
  .ct-follow-actions {
    flex-direction: column;
    width: 100%;
  }

  .ct-follow-card {
    flex-wrap: wrap;
  }

  .ct-follow-pnl,
  .ct-follow-actions {
    width: 100%;
    min-width: 0;
    text-align: left;
  }

  .ct-filters {
    flex-direction: column;
    align-items: stretch;
  }

  .ct-hero h1 {
    font-size: 32px;
  }

  .ct-hero {
    margin-bottom: 22px;
  }

  .ct-page .earning_section_cate ul#myTab {
    gap: 16px;
    flex-wrap: wrap;
  }

  .ct-page .earning_section_cate .nav-tabs .nav-link {
    font-size: 15px;
  }

  .ct-page .earning_tp_heading {
    margin-bottom: 16px;
  }

  .ct-detail-actions .ct-btn {
    width: 100%;
  }

  .ct-win-badge {
    margin-left: 0;
  }

  .ct-pnl-hero h2 {
    font-size: 32px;
  }
}

body.light_theme .ct-page .earning_section_cate {
  background: rgba(255, 255, 255, 0.92);
}

body.light_theme .ct-hero h1 {
  color: #fff;
}

body.light_theme .ct-master-card,
body.light_theme .ct-follow-card,
body.light_theme .ct-pnl-hero,
body.light_theme .ct-detail-stat,
body.light_theme .ct-stat,
body.light_theme .ct-alloc-item,
body.light_theme .ct-notice {
  background: #fff;
  border-color: #e5e5e5;
}

body.light_theme .ct-master-name,
body.light_theme .ct-stat span,
body.light_theme .ct-follow-card h5,
body.light_theme .ct-detail-info h2,
body.light_theme .ct-section-title,
body.light_theme .ct-detail-stat span,
body.light_theme .ct-alloc-item strong,
body.light_theme .ct-page .recenttable_s table tbody tr td,
body.light_theme .ct-notice p {
  color: #111;
}

body.light_theme .ct-btn.outline,
body.light_theme .ct-chip {
  color: #111;
}

body.light_theme .ct-avatar {
  border-color: #fff;
}

body.light_theme .ct-search {
  background: #fff;
  border-color: #e5e5e5;
}

body.light_theme .ct-search input {
  color: #111;
}
`, "",{"version":3,"sources":["webpack://./src/ui/Pages/CopyTrading/copyTrading.css"],"names":[],"mappings":"AAAA;;yCAEyC;;AAEzC;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,yDAAsE;EACtE,+BAA+B;EAC/B,sBAAsB;EACtB,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kCAAkC;EAClC,2CAA2C;AAC7C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,mBAAmB;EACnB,kDAAkD;AACpD;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;;;;EAIE;0FACwF;EACxF,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;AACb;;AAEA;;;EAGE,uBAAuB;EACvB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;;EAEE,uBAAuB;EACvB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;EACd,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;;EAGE,cAAc;EACd,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,uBAAuB;EACvB,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB;;0FAEwF;AAC1F;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,oBAAoB;EACpB,iDAAiD;AACnD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mDAAmD;AACrD;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;;EAGE,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,kDAAkD;EAClD,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE;;IAEE,gDAAgD;EAClD;;EAEA;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;;;;IAIE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,WAAW;IACX,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,WAAW;AACb;;AAEA;;;;;;;EAOE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;;;;;;;;EASE,WAAW;AACb;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb","sourcesContent":["/* Copy Trading — premium static look on Vorienx theme\n   Colors: #0a0a0a, #2563eb, #5EC732, #F6CF25, #F52534\n   No animations / transitions / motion */\n\n.ct-page {\n  min-height: 100vh;\n}\n\nsection.earning_outer_s.ct-page {\n  position: relative;\n  background-color: #0a0a0a;\n  background-image: url(\"../../../../public/images/exchange_herobg.jpg\");\n  background-position: center top;\n  background-size: cover;\n  background-repeat: no-repeat;\n  padding: 110px 0 80px;\n  overflow: hidden;\n}\n\nsection.earning_outer_s.ct-page::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.38);\n  pointer-events: none;\n}\n\n.ct-page > .container {\n  position: relative;\n  z-index: 1;\n}\n\n.ct-hero {\n  margin: 0 0 32px;\n  max-width: 680px;\n}\n\n.ct-hero .ct-kicker {\n  color: #fff;\n  margin-bottom: 12px;\n}\n\n.ct-hero h1 {\n  margin: 0 0 12px;\n  font-size: 46px;\n  font-weight: 800;\n  line-height: 1.12;\n  letter-spacing: -0.8px;\n  color: #fff;\n}\n\n.ct-hero p {\n  margin: 0;\n  font-size: 17px;\n  line-height: 1.55;\n  color: #d4d4d4;\n  max-width: 560px;\n}\n\n.ct-page .earning_section_cate {\n  margin-bottom: 8px;\n  overflow: visible;\n  background: rgba(10, 10, 10, 0.82);\n  border: 1px solid rgba(120, 120, 120, 0.45);\n}\n\n.ct-page .earning_right_tab {\n  width: 100%;\n}\n\n.ct-page .earning_right_tab .nav-tabs {\n  flex-wrap: wrap;\n  justify-content: flex-start;\n}\n\n.ct-page-head {\n  position: relative;\n  z-index: 1;\n  margin-bottom: 8px;\n  padding-bottom: 8px;\n  border-bottom: 1px solid rgba(120, 120, 120, 0.35);\n}\n\n.ct-page .earning_tp_heading {\n  align-items: flex-start;\n}\n\n.ct-page .earning_tp_heading h4 {\n  letter-spacing: -0.3px;\n}\n\n.ct-page-sub {\n  margin: 4px 0 0;\n  font-size: 12px;\n  color: #9b9999;\n  font-weight: 400;\n  line-height: 1.45;\n}\n\n.ct-kicker {\n  display: inline-block;\n  margin-bottom: 8px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 1.4px;\n  text-transform: uppercase;\n  color: #9b9999;\n}\n\n.ct-toolbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n  margin: 8px 0 26px;\n}\n\n.ct-search {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex: 0 0 280px;\n  max-width: 100%;\n  background: #222222;\n  border: 1px solid #7878789c;\n  border-radius: 50px;\n  padding: 8px 16px;\n}\n\n.ct-search i {\n  color: #9b9999;\n  font-size: 16px;\n  line-height: 1;\n  flex-shrink: 0;\n}\n\n.ct-search input {\n  flex: 1;\n  min-width: 0;\n  width: 100%;\n  border: none;\n  outline: none;\n  background: transparent;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 400;\n}\n\n.ct-search input::placeholder {\n  color: #9b9999;\n}\n\n.ct-search input:focus {\n  border: none;\n  outline: none;\n  box-shadow: none;\n}\n\n.ct-notice {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  max-width: 560px;\n  padding: 10px 14px;\n  border-radius: 12px;\n  background: transparent;\n  border: 1px solid #7878789c;\n}\n\n.ct-notice p {\n  margin: 0;\n  font-size: 12px;\n  line-height: 1.5;\n  color: #9b9999;\n}\n\n.ct-notice-dot {\n  width: 6px;\n  height: 6px;\n  margin-top: 6px;\n  border-radius: 50%;\n  background: #787878;\n  box-shadow: none;\n  flex-shrink: 0;\n}\n\n.ct-master-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 22px;\n}\n\n.ct-master-card,\n.ct-follow-card,\n.ct-detail-stat,\n.ct-pnl-hero {\n  background:\n    linear-gradient(180deg, rgba(255, 255, 255, 0.04) 0%, rgba(255, 255, 255, 0.015) 100%);\n  border: 1px solid rgba(120, 120, 120, 0.42);\n  position: relative;\n}\n\n.ct-master-card {\n  background: #0a0a0a;\n  border: 1px solid #7878789c;\n  border-radius: 16px;\n  padding: 20px 18px 16px;\n  display: flex;\n  flex-direction: column;\n  min-height: 100%;\n  overflow: hidden;\n  box-shadow: none;\n}\n\n.ct-master-card::before {\n  display: none;\n}\n\n.ct-master-card.is-following {\n  border-color: #7878789c;\n}\n\n.ct-master-card .ct-avatar-wrap {\n  padding: 0;\n  background: #1a1a1a;\n  border: 1px solid #7878789c;\n}\n\n.ct-master-card .ct-avatar {\n  border-color: #0a0a0a;\n}\n\n.ct-master-card .ct-chip.pair,\n.ct-master-card .ct-chip.following {\n  color: #cfcfcf;\n  background: transparent;\n  border-color: #7878789c;\n  font-weight: 600;\n}\n\n.ct-master-card .ct-win-badge {\n  background: transparent;\n  color: #cfcfcf;\n  border-color: #7878789c;\n  font-weight: 600;\n}\n\n.ct-master-card .ct-rating-stars i {\n  color: #F6CF25;\n}\n\n.ct-master-card .ct-rating-stars i.empty {\n  color: rgba(246, 207, 37, 0.28);\n}\n\n.ct-master-card .ct-rating-value {\n  color: #fff;\n}\n\n.ct-master-card .ct-stat,\n.ct-master-card .ct-stat.profit,\n.ct-master-card .ct-stat.loss {\n  background: transparent;\n  border: 1px solid #7878789c;\n  border-radius: 10px;\n}\n\n.ct-master-card .ct-alloc-item,\n.ct-master-card .ct-alloc-item.gold {\n  background: transparent;\n  border: 1px solid #7878789c;\n  border-radius: 10px;\n}\n\n.ct-master-card .ct-alloc-item.gold strong {\n  color: #fff;\n}\n\n.ct-master-card .ct-btn.primary {\n  box-shadow: none;\n}\n\n.ct-master-card-head {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n  margin-bottom: 16px;\n}\n\n.ct-master-card-head .ct-master-copy {\n  flex: 1;\n  min-width: 0;\n}\n\n.ct-avatar-wrap {\n  width: 62px;\n  height: 62px;\n  border-radius: 50%;\n  padding: 0;\n  background: #1a1a1a;\n  border: 1px solid #7878789c;\n  flex-shrink: 0;\n}\n\n.ct-avatar-wrap.lg {\n  width: 96px;\n  height: 96px;\n  padding: 0;\n}\n\n.ct-avatar-wrap.is-following {\n  background: #1a1a1a;\n  border-color: #7878789c;\n}\n\n.ct-avatar {\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  object-fit: cover;\n  background: #111;\n  display: block;\n  border: 2px solid #0a0a0a;\n}\n\n.ct-name-row {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.ct-master-name {\n  margin: 0;\n  font-size: 19px;\n  font-weight: 700;\n  color: #fff;\n  letter-spacing: -0.2px;\n}\n\n.ct-master-bio {\n  margin: 7px 0 0;\n  font-size: 13px;\n  color: #9b9999;\n  line-height: 1.5;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.ct-rating {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.ct-rating-stars {\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n}\n\n.ct-rating-stars i {\n  font-size: 14px;\n  line-height: 1;\n  color: #F6CF25;\n}\n\n.ct-rating-stars i.empty {\n  color: rgba(246, 207, 37, 0.28);\n}\n\n.ct-rating-value {\n  font-size: 13px;\n  font-weight: 700;\n  color: #fff;\n  letter-spacing: -0.2px;\n}\n\n.ct-rating.none .ct-rating-value {\n  color: #9b9999;\n  font-weight: 600;\n}\n\n.ct-rating.lg {\n  margin: 10px 0 2px;\n}\n\n.ct-rating.lg .ct-rating-stars i {\n  font-size: 20px;\n}\n\n.ct-rating.lg .ct-rating-value {\n  font-size: 20px;\n}\n\n.ct-win-badge {\n  display: inline-flex;\n  align-items: center;\n  background: transparent;\n  color: #cfcfcf;\n  border: 1px solid #7878789c;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.3px;\n  padding: 5px 11px;\n  border-radius: 50px;\n  white-space: nowrap;\n  margin-left: auto;\n}\n\n.ct-chip-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin: 0 0 16px;\n}\n\n.ct-chip {\n  display: inline-flex;\n  align-items: center;\n  font-size: 11px;\n  font-weight: 700;\n  color: #cfcfcf;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.09);\n  border-radius: 50px;\n  padding: 4px 10px;\n}\n\n.ct-chip.pair,\n.ct-chip.following {\n  color: #cfcfcf;\n  background: transparent;\n  border-color: #7878789c;\n  font-weight: 600;\n}\n\n.ct-stats {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n  margin: 0 0 14px;\n}\n\n.ct-stat {\n  background: rgba(0, 0, 0, 0.32);\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  border-radius: 14px;\n  padding: 12px 13px;\n  border-left: 2px solid rgba(37, 99, 235, 0.55);\n}\n\n.ct-stat.profit {\n  border-left-color: #5EC732;\n}\n\n.ct-stat.loss {\n  border-left-color: #F52534;\n}\n\n.ct-stat label,\n.ct-alloc-item label,\n.ct-follow-pnl label {\n  display: block;\n  font-size: 10px;\n  color: #9b9999;\n  text-transform: uppercase;\n  letter-spacing: 0.7px;\n  margin-bottom: 5px;\n}\n\n.ct-stat span {\n  font-size: 15px;\n  font-weight: 700;\n  color: #fff;\n  letter-spacing: -0.2px;\n}\n\n.ct-alloc {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n  margin: 0 0 16px;\n}\n\n.ct-alloc-item,\n.ct-alloc-item.gold {\n  background: transparent;\n  border: 1px solid #7878789c;\n  border-radius: 10px;\n  padding: 11px 13px;\n}\n\n.ct-alloc-item strong,\n.ct-alloc-item.gold strong {\n  display: block;\n  font-size: 18px;\n  font-weight: 700;\n  color: #fff;\n  letter-spacing: -0.3px;\n}\n\n.ct-note {\n  font-size: 12px;\n  color: #9b9999;\n  margin: 0 0 16px;\n  line-height: 1.5;\n}\n\n.ct-note strong {\n  color: #fff;\n  font-weight: 600;\n}\n\n.ct-card-actions {\n  display: flex;\n  gap: 10px;\n  margin-top: auto;\n}\n\n.ct-btn {\n  flex: 1;\n  border: none;\n  padding: 11px 16px;\n  font-size: 13px;\n  font-weight: 700;\n  border-radius: 50px;\n  cursor: pointer;\n  text-align: center;\n  text-decoration: none;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  white-space: nowrap;\n}\n\n.ct-btn.primary {\n  background-color: #2563eb;\n  color: #fff;\n  box-shadow: none;\n}\n\n.ct-btn.primary:hover {\n  background-color: #1d4ed8;\n  color: #fff;\n}\n\n.ct-btn.light {\n  background-color: #fff;\n  color: #000;\n}\n\n.ct-btn.light:hover {\n  background-color: #e8e8e8;\n  color: #000;\n}\n\n.ct-btn.outline {\n  background: transparent;\n  border: 1px solid #7878789c;\n  color: #fff;\n}\n\n.ct-btn.outline:hover {\n  border-color: #fff;\n  color: #fff;\n}\n\n.ct-btn.danger {\n  background: transparent;\n  border: 1px solid rgba(245, 37, 52, 0.7);\n  color: #F52534;\n}\n\n.ct-btn.danger:hover {\n  background: rgba(245, 37, 52, 0.12);\n}\n\n.ct-btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n.ct-pnl-positive {\n  color: #5EC732 !important;\n}\n\n.ct-pnl-negative {\n  color: #F52534 !important;\n}\n\n.ct-status {\n  display: inline-block;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.4px;\n  padding: 4px 10px;\n  border-radius: 50px;\n}\n\n.ct-status.open {\n  background: rgba(246, 207, 37, 0.15);\n  color: #F6CF25;\n}\n\n.ct-status.executed {\n  background: rgba(94, 199, 50, 0.15);\n  color: #5EC732;\n}\n\n.ct-status.cancelled {\n  background: rgba(155, 153, 153, 0.18);\n  color: #9b9999;\n}\n\n.ct-side.buy {\n  color: #5EC732;\n  font-weight: 700;\n}\n\n.ct-side.sell {\n  color: #F52534;\n  font-weight: 700;\n}\n\n.ct-login-prompt {\n  text-align: center;\n  padding: 40px 16px;\n}\n\n.ct-login-prompt a {\n  color: #2563eb;\n  font-weight: 700;\n}\n\n.ct-filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  align-items: center;\n  margin: 18px 0 20px;\n}\n\n.ct-filters select {\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid #7878789c;\n  color: #fff;\n  border-radius: 50px;\n  padding: 9px 16px;\n  font-size: 14px;\n  outline: none;\n  min-width: 160px;\n}\n\n.ct-filters select option {\n  background: #111;\n  color: #fff;\n}\n\n.ct-filters .ct-notice {\n  flex: 1 1 280px;\n  max-width: none;\n}\n\n.ct-pnl-hero {\n  border-radius: 20px;\n  padding: 36px 24px 32px;\n  margin: 18px 0 24px;\n  text-align: center;\n  overflow: hidden;\n  background:\n    radial-gradient(700px 180px at 50% 0%, rgba(37, 99, 235, 0.2), transparent 70%),\n    linear-gradient(180deg, rgba(255, 255, 255, 0.04) 0%, rgba(255, 255, 255, 0.015) 100%);\n}\n\n.ct-pnl-hero label {\n  display: block;\n  color: #9b9999;\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 1.2px;\n  margin-bottom: 10px;\n}\n\n.ct-pnl-hero h2 {\n  margin: 0 auto;\n  font-size: 44px;\n  font-weight: 700;\n  letter-spacing: -0.8px;\n  display: inline-block;\n  padding-bottom: 10px;\n  border-bottom: 2px solid rgba(246, 207, 37, 0.45);\n}\n\n.ct-pnl-hero .ct-page-sub {\n  margin-top: 12px;\n}\n\n.ct-follow-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 18px;\n  margin-top: 8px;\n}\n\n.ct-follow-card {\n  border-radius: 20px;\n  padding: 18px 20px;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.05);\n}\n\n.ct-follow-card .ct-follow-meta {\n  flex: 1;\n  min-width: 0;\n}\n\n.ct-follow-card h5 {\n  margin: 0;\n  font-size: 16px;\n  color: #fff;\n  font-weight: 700;\n}\n\n.ct-follow-card p {\n  margin: 6px 0 0;\n  font-size: 13px;\n  color: #9b9999;\n}\n\n.ct-follow-pnl {\n  min-width: 128px;\n  text-align: right;\n}\n\n.ct-follow-pnl strong {\n  display: block;\n  font-size: 16px;\n  font-weight: 700;\n  color: #fff;\n}\n\n.ct-follow-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 118px;\n  flex-shrink: 0;\n}\n\n.ct-detail-head {\n  display: flex;\n  align-items: flex-start;\n  gap: 24px;\n  flex-wrap: wrap;\n  margin-bottom: 26px;\n  position: relative;\n  z-index: 1;\n}\n\n.ct-detail-info {\n  flex: 1;\n  min-width: 240px;\n}\n\n.ct-detail-info h2 {\n  margin: 0;\n  font-size: 32px;\n  font-weight: 700;\n  color: #fff;\n  letter-spacing: -0.5px;\n}\n\n.ct-detail-info > p {\n  margin: 10px 0 16px;\n  color: #9b9999;\n  line-height: 1.6;\n  max-width: 640px;\n}\n\n.ct-detail-info .ct-win-badge {\n  margin-left: 0;\n}\n\n.ct-detail-info .ct-alloc {\n  max-width: 420px;\n  margin-bottom: 14px;\n}\n\n.ct-detail-info .ct-notice {\n  margin-bottom: 16px;\n}\n\n.ct-detail-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.ct-detail-actions .ct-btn {\n  flex: 0 0 auto;\n  min-width: 168px;\n}\n\n.ct-back {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  color: #cfcfcf;\n  font-size: 14px;\n  text-decoration: none;\n  margin-bottom: 18px;\n  position: relative;\n  z-index: 1;\n}\n\n.ct-back:hover {\n  color: #fff;\n}\n\n.ct-detail-stats {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 14px;\n  margin-bottom: 4px;\n}\n\n.ct-detail-stat {\n  background: #0a0a0a;\n  border: 1px solid #7878789c;\n  border-radius: 12px;\n  padding: 16px;\n  overflow: hidden;\n  box-shadow: none;\n}\n\n.ct-detail-stat.profit,\n.ct-detail-stat.loss,\n.ct-detail-stat.win {\n  border-color: #7878789c;\n}\n\n.ct-detail-stat label {\n  display: block;\n  font-size: 11px;\n  color: #9b9999;\n  text-transform: uppercase;\n  letter-spacing: 0.6px;\n  margin-bottom: 8px;\n}\n\n.ct-detail-stat span {\n  font-size: 20px;\n  font-weight: 700;\n  color: #fff;\n  letter-spacing: -0.3px;\n}\n\n.ct-section-title {\n  margin: 0 0 16px;\n  font-size: 20px;\n  font-weight: 700;\n  color: #fff;\n  letter-spacing: -0.2px;\n}\n\n.ct-table-card {\n  margin-top: 24px;\n}\n\n.ct-pagination {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 12px;\n  margin-top: 16px;\n  color: #9b9999;\n  font-size: 13px;\n}\n\n.ct-pagination button {\n  background: transparent;\n  border: 1px solid #7878789c;\n  color: #fff;\n  border-radius: 50px;\n  padding: 6px 14px;\n  cursor: pointer;\n}\n\n.ct-pagination button:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.ct-page .recenttable_s table {\n  width: 100%;\n}\n\n.ct-page .recenttable_s table thead tr th {\n  background-color: transparent;\n  color: #ffffff99;\n  font-weight: 600;\n  white-space: nowrap;\n  font-size: 12px;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n  border-bottom: 1px solid #7878789c;\n  padding: 12px 12px;\n}\n\n.ct-page .recenttable_s table tbody tr td {\n  padding: 15px 12px;\n  font-size: 14px;\n  color: #fff;\n  border-bottom: 1px solid rgba(120, 120, 120, 0.24);\n  white-space: nowrap;\n}\n\n.ct-clickable {\n  cursor: pointer;\n}\n\n.ct-clickable:hover {\n  background: rgba(37, 99, 235, 0.08);\n}\n\n@media (max-width: 1199.98px) {\n  .ct-master-grid,\n  .ct-follow-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .ct-detail-stats {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 767.98px) {\n  .ct-hero {\n    margin-bottom: 22px;\n  }\n\n  .ct-hero h1 {\n    font-size: 32px;\n  }\n\n  .ct-master-grid,\n  .ct-follow-grid,\n  .ct-detail-stats,\n  .ct-alloc {\n    grid-template-columns: 1fr;\n  }\n\n  .ct-toolbar {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .ct-toolbar .ct-search {\n    flex: 1 1 auto;\n    width: 100%;\n  }\n\n  .ct-detail-head {\n    flex-direction: column;\n  }\n\n  .ct-card-actions,\n  .ct-follow-actions {\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .ct-follow-card {\n    flex-wrap: wrap;\n  }\n\n  .ct-follow-pnl,\n  .ct-follow-actions {\n    width: 100%;\n    min-width: 0;\n    text-align: left;\n  }\n\n  .ct-filters {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .ct-hero h1 {\n    font-size: 32px;\n  }\n\n  .ct-hero {\n    margin-bottom: 22px;\n  }\n\n  .ct-page .earning_section_cate ul#myTab {\n    gap: 16px;\n    flex-wrap: wrap;\n  }\n\n  .ct-page .earning_section_cate .nav-tabs .nav-link {\n    font-size: 15px;\n  }\n\n  .ct-page .earning_tp_heading {\n    margin-bottom: 16px;\n  }\n\n  .ct-detail-actions .ct-btn {\n    width: 100%;\n  }\n\n  .ct-win-badge {\n    margin-left: 0;\n  }\n\n  .ct-pnl-hero h2 {\n    font-size: 32px;\n  }\n}\n\nbody.light_theme .ct-page .earning_section_cate {\n  background: rgba(255, 255, 255, 0.92);\n}\n\nbody.light_theme .ct-hero h1 {\n  color: #fff;\n}\n\nbody.light_theme .ct-master-card,\nbody.light_theme .ct-follow-card,\nbody.light_theme .ct-pnl-hero,\nbody.light_theme .ct-detail-stat,\nbody.light_theme .ct-stat,\nbody.light_theme .ct-alloc-item,\nbody.light_theme .ct-notice {\n  background: #fff;\n  border-color: #e5e5e5;\n}\n\nbody.light_theme .ct-master-name,\nbody.light_theme .ct-stat span,\nbody.light_theme .ct-follow-card h5,\nbody.light_theme .ct-detail-info h2,\nbody.light_theme .ct-section-title,\nbody.light_theme .ct-detail-stat span,\nbody.light_theme .ct-alloc-item strong,\nbody.light_theme .ct-page .recenttable_s table tbody tr td,\nbody.light_theme .ct-notice p {\n  color: #111;\n}\n\nbody.light_theme .ct-btn.outline,\nbody.light_theme .ct-chip {\n  color: #111;\n}\n\nbody.light_theme .ct-avatar {\n  border-color: #fff;\n}\n\nbody.light_theme .ct-search {\n  background: #fff;\n  border-color: #e5e5e5;\n}\n\nbody.light_theme .ct-search input {\n  color: #111;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
